import styled from '@emotion/styled';
import React, { InputHTMLAttributes, useState } from 'react';

import closedEyeIcon from 'src/public/img/eye-closed.svg';
import openEyeIcon from 'src/public/img/eye-open.svg';
import { Input, InputType } from './Input';

const PasswordInputWrapper = styled.div({
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    position: 'relative',
    '> div': {
        position: 'static',
    },
});
const EyeIcon = styled.img({
    position: 'absolute',
    right: 0,
    padding: '8px',
    cursor: 'pointer',
});
interface PasswordInputProps extends InputHTMLAttributes<HTMLInputElement> {
    fieldId: string;
    error?: string;
    label: string;
    testID?: string;
}
export const PasswordInput: React.FC<PasswordInputProps> = ({
    fieldId,
    value,
    onChange,
    onBlur,
    label,
    error,
    testID,
}) => {
    const [passwordVisible, setPasswordVisible] = useState(false);

    return (
        <PasswordInputWrapper>
            <Input
                type={passwordVisible ? InputType.TextField : InputType.Password}
                fieldId={fieldId}
                value={value}
                onBlur={onBlur}
                onChange={onChange}
                label={label}
                error={error}
                testID={testID}
            />
            <EyeIcon
                src={passwordVisible ? openEyeIcon : closedEyeIcon}
                onClick={() => setPasswordVisible(!passwordVisible)}
            />
        </PasswordInputWrapper>
    );
};
